import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const RmmRoutes: RouteRecordRaw[] = [
    {
        name: 'rmm',
        path: '',
        meta: makePermissionMeta('msp'),
        component: wrapRuntimeImport(() => import('./screens/console.vue'))
    },
    {
        name: 'rmm-endpoint',
        path: 'endpoints/:agentId',
        meta: makePermissionMeta('msp'),
        component: wrapRuntimeImport(() => import('./screens/console.vue'))
    },
    {
        name: 'rmm-endpoint-tab',
        path: 'endpoints/:agentId/:tab?',
        meta: makePermissionMeta('msp'),
        component: wrapRuntimeImport(() => import('./screens/console.vue'))
    },
    {
        name: 'rmm-networks',
        path: 'networks',
        meta: makePermissionMeta('msp'),
        component: wrapRuntimeImport(() => import('./screens/networks.vue'))
    },
    {
        name: 'rmm-network',
        path: 'networks/:networkId',
        meta: makePermissionMeta('msp'),
        component: wrapRuntimeImport(() => import('./screens/networks.vue'))
    },
    {
        path: 'settings',
        meta: makePermissionMeta('msp'),
        component: wrapRuntimeImport(() => import('./screens/settings.vue')),
        children: [
            { path: '', redirect: '/rmm/settings/devices' },
            {
                path: 'technicians',
                component: wrapRuntimeImport(() => import('./screens/settings/technicians.vue')),
                meta: makePermissionMeta('msp')
            },
            {
                path: 'org-users',
                component: wrapRuntimeImport(() => import('./screens/settings/org-users.vue')),
                meta: makePermissionMeta('msp')
            },
            { path: 'devices', component: wrapRuntimeImport(() => import('./screens/settings/devices.vue')), meta: makePermissionMeta('msp') },
            {
                path: 'enrollment-tokens',
                component: wrapRuntimeImport(() => import('./screens/settings/enrollment-tokens.vue')),
                meta: makePermissionMeta('msp')
            },
            { path: 'tags', component: wrapRuntimeImport(() => import('./screens/settings/tags.vue')), meta: makePermissionMeta('msp') },
            {
                path: 'network-discovery',
                component: wrapRuntimeImport(() => import('./screens/settings/network-discovery.vue')),
                meta: makePermissionMeta('msp')
            },
            { path: 'scripts', component: wrapRuntimeImport(() => import('./screens/settings/scripts.vue')), meta: makePermissionMeta('msp') },
            { path: 'upgrades', component: wrapRuntimeImport(() => import('./screens/settings/upgrades.vue')), meta: makePermissionMeta('msp') }
        ]
    }
];
